"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingReportFileStatus = void 0;
exports.RoutingReportFileStatus = {
    Pending: "PENDING",
    Processing: "PROCESSING",
    Done: "DONE",
    Error: "ERROR",
    Invalid: "INVALID",
};
//# sourceMappingURL=routing-report-file-status.js.map